import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import chroma from 'chroma-js';

@Injectable({ providedIn: 'root' })
export class ThemePaletteService {
    constructor(@Inject(DOCUMENT) private document: Document) {}

    generatePalette(config: string | Record<string, string>) {
        const palette: Record<string, string> = {
            50: '',
            100: '',
            200: '',
            300: '',
            400: '',
            500: '',
            600: '',
            700: '',
            800: '',
            900: '',
        };

        if (typeof config === 'string') {
            palette['500'] = chroma.valid(config) ? config : '';
        } else if (typeof config === 'object' && chroma.valid(config['500'])) {
            Object.keys(palette).forEach((key) => {
                palette[key] = chroma.valid(config[key]) ? config[key] : '';
            });
        } else {
            throw new Error('Config must have a valid 500 color');
        }

        const colors = Object.values(palette).filter(Boolean);
        colors.unshift(chroma.scale(['white', palette['500']]).domain([0, 1]).mode('lrgb').colors(50)[1]);
        colors.push(chroma.scale(['black', palette['500']]).domain([0, 1]).mode('lrgb').colors(10)[1]);

        const domain = [
            0,
            ...Object.entries(palette)
                .filter(([_, v]) => v)
                .map(([k]) => parseInt(k) / 1000),
            1,
        ];

        const scale = chroma.scale(colors).domain(domain).mode('lrgb');

        return {
            50: scale(0.05).hex(),
            100: scale(0.1).hex(),
            200: scale(0.2).hex(),
            300: scale(0.3).hex(),
            400: scale(0.4).hex(),
            500: scale(0.5).hex(),
            600: scale(0.6).hex(),
            700: scale(0.7).hex(),
            800: scale(0.8).hex(),
            900: scale(0.9).hex(),
        };
    }
    generateOnPalette(palette: Record<string, string>): Record<string, string> {
        const lightColor = '#FFFFFF';
        let darkColor = '#FFFFFF';

        // Encontra o tom mais escuro da paleta
        Object.values(palette).forEach((color) => {
            darkColor = chroma.contrast(color, lightColor) > chroma.contrast(darkColor, lightColor) ? color : darkColor;
        });

        // Gera o onPalette baseado no maior contraste
        const onPalette: Record<string, string> = {};
        Object.entries(palette).forEach(([hue, color]) => {
            onPalette[hue] = chroma.contrast(color, darkColor) > chroma.contrast(color, lightColor) ? darkColor : lightColor;
        });

        return onPalette;
    }
    setPaletteVars(palette: Record<string, string>, prefix = '--devstroupe-primary', themeClass = 'theme-default') {
        let themeElement: HTMLElement | null = null;

        // if (this.document.body.classList.contains(themeClass)) {
        themeElement = this.document.body;
        // } else {
        //     const el = this.document.body.querySelector(`.${themeClass}`);
        //     if (el && el instanceof HTMLElement) {
        //         themeElement = el;
        //     }
        // }

        if (!themeElement) {
            console.warn(`[ThemePaletteService] Elemento com a classe '${themeClass}' não encontrado.`);
            return;
        }

        Object.entries(palette).forEach(([key, value]) => {
            const rgb = chroma(value).rgb().join(',');
            themeElement.style.setProperty(`${prefix}-${key}-rgb`, rgb, 'important');
            themeElement.style.setProperty(`${prefix}-${key}`, value, 'important');
            if (key === '500') {
                themeElement.style.setProperty(`${prefix}-contrast`, chroma(value).luminance() > 0.5 ? 'black' : 'white', 'important');
                themeElement.style.setProperty(`${prefix}-rgb`, rgb, 'important');
                themeElement.style.setProperty(`${prefix}`, value, 'important');
            }
        });

        const onPalette = this.generateOnPalette(palette);
        Object.entries(onPalette).forEach(([key, value]) => {
            const rgb = chroma(value).rgb().join(',');
            themeElement.style.setProperty(`--devstroupe-on-primary-${key}-rgb`, rgb, 'important');
            themeElement.style.setProperty(`--devstroupe-on-primary-${key}`, value, 'important');
            if (key === '500') {
                themeElement.style.setProperty(`--devstroupe-on-primary-contrast`, chroma(value).luminance() > 0.5 ? 'black' : 'white', 'important');
                themeElement.style.setProperty(`--devstroupe-on-primary-rgb`, rgb, 'important');
                themeElement.style.setProperty(`--devstroupe-on-primary`, value, 'important');
            }
        });

        // console.log(`[ThemePaletteService] Variáveis CSS setadas em`, themeElement);
    }

    applyPrimaryColor(color: string) {
        const palette = this.generatePalette(color);
        this.setPaletteVars(palette);
    }
}
